import { render } from "./CompanyType.vue?vue&type=template&id=57a2a711&scoped=true"
import script from "./CompanyType.vue?vue&type=script&lang=js"
export * from "./CompanyType.vue?vue&type=script&lang=js"

import "./CompanyType.vue?vue&type=style&index=0&id=57a2a711&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a2a711"]])

export default __exports__